<template>
  <div>

    <vue-chart
      chart-type="PieChart"
      :columns="columns"
      :rows="rows"
      :options="options">
    </vue-chart>

  </div>
</template>


<script>
export default {
  props: ['assets'],
  data() {
    return {
      columns: [
        {
          'type': 'string',
          'label': 'Coin',
        },
        {
          'type': 'number',
          'label': 'Value in BGN',
        },
        {
          'type': 'string',
          'role': 'tooltip',
          'p': {'html': true},
        },
      ],
      options: {
        width: 800,
        height: 500,
        is3D: true,
        legend: 'labeled',
        pieSliceText: 'none',
        tooltip: {
          isHtml: true,
        },
      },
    }
  },
  computed: {
    rows: function() {
      return this.assets.map(asset => [
        asset.name,
        asset.valueBGN,
        '<div class="assets-tooltip">' + asset.valueBGN + ' BGN</div>',
      ])
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/components/charts/AssetsPieChart.vue